import moment from "moment";

export default class UserInvitationUrl {
    constructor(
        public readonly url: string,
        public readonly validTo: moment.Moment,
    ) {}
}